module.exports = __webpack_public_path__ + "img/map-ethiopia.096aecc9.png";